import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import { formatDate, myId } from '../../lib/MyLibrary';

const ShowDataVtex = ({data, myFontSize}) => {
  const [dataClientCL, setDataClientCL] = useState([]);
  const [dataClientMF, setDataClientMF] = useState([]);
  const {dataCL, dataMF}= data.data;
  useEffect(() => {
    if(dataCL[0]){
      const tempArrayCL = [
        [ 'idAptos:', String(dataCL[0].idAptos)||'null'],
        [ 'idCL:', dataCL[0].id||'null'],
        [ 'email:', dataCL[0].email||'null'],
        [ 'Nombre:', dataCL[0].firstName||'null'],
        [ 'Apellidos:', dataCL[0].lastName||'null'],
        [ 'Fecha Nacimiento:', formatDate(new Date(dataCL[0].birthDate))||'null' ],
        [ 'Género:', dataCL[0].gender||'null'],
        ['Teléfono:', dataCL[0].phone||'null'],
        [ 'Código Postal:', dataCL[0].codigoPostal||'null'],
        [ 'Cupón:', dataCL[0].cuponml||'null'],
        [ 'Cupón online:', String(dataCL[0].cupononline)||'null'],
        [ 'Cupón Vigencia:',String(dataCL[0].cuponvigencia)||'null'],
        [ 'Nombre de Cuenta:', dataCL[0].accountName||'null'],
        [ 'Fecha de Creación:', dataCL[0].createdIn||'null'],
        [ 'Programa ML:', String(dataCL[0].programaml)||'null'],
        [ 'Puntos ML:',String(dataCL[0].puntosml)||'null'],
        [ 'Newsletter:', String(dataCL[0].isNewsletterOptIn)||'null']
      ]
      setDataClientCL(tempArrayCL);
    } else setDataClientCL(null);
    
    if (dataMF[0]){
      const tempArrayMF = [
        [ 'idAptos:', dataCL[0].idAptos||'null'],
        [ 'idMF:', dataMF[0].id||'null'],
        [ 'email:', dataMF[0].email||'null'],
        [ 'Nombre:', dataMF[0].name||'null'],
        [ 'Apellidos:', dataMF[0].lastname||'null'],
        [ 'Género:', dataMF[0].gender||'null'],
        [ 'Estado Civil:', dataMF[0].maritalstatus||'null'],
        [ 'Fecha de Nacimiento:', dataMF[0].date||formatDate(new Date(dataCL[0].birthDate))||'null'],
        [ 'Código Postal:', dataMF[0].postalcode||'null'],
        [ 'Teléfono:', dataMF[0].homePhone||'null'],
        [ 'Cupón:', dataMF[0].cupon||'null'],
        [ 'Cupón on Line:', String(dataMF[0].cupononline)||'null'],
        [ 'Fecha de Creación:', dataMF[0].createdIn||'null'],
        [ 'Intereses:', dataMF[0].interests||'null'],
        [ 'Plan de Lealtad:', String(dataMF[0].isJoinedPL)||'null'],
        [ 'Newsletter:', String(dataMF[0].newsletter)||'null'],
        [ 'Aviso de Privacidad:', String(dataMF[0].privacy)||'null'],
        [ 'Términos y Condiciones:', String(dataMF[0].tyc)||'null'],
      ]
      setDataClientMF(tempArrayMF);
    }else {
      setDataClientMF(null);
    }
    
    return 
  }, [])
  
  return (
    <div>
      <Container fluid style={{width: "90%"}} className='border borde-2 bg-light p-3 rounded'>
        
     
      {dataClientCL && 
      <div>
            <h3 className='text-center text-secondary fs-3'>Data Entity CL</h3>
        {
          dataClientCL.map(item=>{
            return <p key={myId()} style={{ width: "90%" }} className="text-secondary fs-6 my-0 ms-auto me-auto">
            <span style={{ width: "40%", fontSize: myFontSize}} className="border border-2 d-inline-block ps-2 pt-1">{item[0]}</span>
            <span style={{ width: "60%", fontSize: myFontSize}} className="border border-2 text-danger d-inline-block ps-2 pt-1">{item[1]}</span>
          </p>
          })
        }
      </div>
      }
     

     {dataClientMF && 
      <div>
            <h3 className='text-center text-secondary fs-3'>Data Entity MF</h3>
        {
          dataClientMF.map(item=>{
            return <p key={myId()} style={{ width: "90%" }} className="text-secondary fs-6 my-0 ms-auto me-auto">
            <span style={{ width: "40%", fontSize: myFontSize }} className="border border-2 d-inline-block ps-2 pt-1">{item[0]}</span>
            <span style={{ width: "60%", fontSize: myFontSize }} className="border border-2 text-danger d-inline-block ps-2 pt-1">{item[1]}</span>
          </p>
          })
        }
      </div>
      }

       


      </Container>
    </div>
  )
}

export default ShowDataVtex